import { SettingsPage } from '@/features/settings';

export default function SettingsRoute() {
  return <SettingsPage />;
}
